import React, { PropTypes } from 'react';

const Teaser = props => {
  const css = require('./Teaser.scss');
  return (
      <article className={css.teaser}
          key={props.id}
      >
          <a href={props.url}>
              <img src={'img/' + props.id} />
              <h1>{props.title}</h1>
          </a>
      </article>
  );
};

Teaser.displayName = 'Teaser';
Teaser.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string
};

export default Teaser;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Teaser.js
 **/